export const createJSONResponseHandler = (name, cb = data => data) => async res => {
  let data = null
  if (res.status === 204) return cb(data)
  try {
    const contentType = res?.headers?.get('content-type')

    switch (contentType) {
      case 'application/zip':
        data = await res.arrayBuffer()
        break
      case 'text/csv':
        data = await res.text()
        break
      default:
        data = await res.json()
        break
    }
  } catch (error) {
    console.error(`An error occurred in ${name}:`, error)
  }

  if (!res.ok) {
    const e = new Error(`${name} - ${res.status}`)
    e.data = data?.error ? data.error : data
    e.status = res.status
    throw e
  }
  return cb(data)
}
